import { INotification } from "infrastructure/notification";
import { IPickerSearchCriterion } from "ui/screens/security/shared/picker";

export interface ITenantSearchCriterion extends IPickerSearchCriterion<ITenant> {
  enterpriseId?: string;
}

export interface ITenant {
  tenantId: string;
  tenantName: string;
}

export interface ITenantsState {
  [x: string]: ITenantsList;
}

export interface ITenantsList {
  items: ITenant[];
  isLoading: boolean;
  initialized: boolean;
  notification?: INotification;
}

export const getInitialTenantsState = (): ITenantsState => {
  return {};
};
